import { render, staticRenderFns } from "./ExportBadgesModal.vue?vue&type=template&id=42c31319"
import script from "./ExportBadgesModal.vue?vue&type=script&lang=js"
export * from "./ExportBadgesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports